import {computed, inject} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {patchState, signalStore, withComputed, withHooks, withState} from '@ngrx/signals';

interface LayoutState {
	isMobile: boolean;
	isTablet: boolean;
}

const initialState: LayoutState = {
	isMobile: false,
	isTablet: false,
};

/**
 * Viewport partagé, source unique alignée sur `src/_breakpoints.scss` :
 * `isMobile` < 600px ≤ `isTablet` < 960px ≤ desktop. `isHandset` couvre les
 * deux — c'est le seuil où le menu passe en overlay.
 *
 * Remplace toute détection par user-agent (Bowser) : l'UA ment (iPad se
 * déclare tablet, une fenêtre étroite se déclare desktop), la largeur non.
 */
export const LayoutStore = signalStore(
	{providedIn: 'root'},
	withState(initialState),
	withComputed((store) => ({
		isHandset: computed(() => store.isMobile() || store.isTablet()),
	})),
	withHooks({
		onInit(store) {
			inject(BreakpointObserver)
				.observe([Breakpoints.XSmall, Breakpoints.Small])
				.pipe(takeUntilDestroyed())
				.subscribe(result => patchState(store, {
					isMobile: result.breakpoints[Breakpoints.XSmall],
					isTablet: result.breakpoints[Breakpoints.Small],
				}));
		},
	}),
);
